import React from 'react';
import {
  Datagrid,
  DateField,
  Filter,
  FunctionField,
  List,
  NumberField,
  ReferenceField,
  SearchInput,
  TextField,
  TextInput,
} from 'react-admin';
import { Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Permission } from '../../components';
import { PERMISSIONS } from '../../constants';

const skippedFilters = [
  <SearchInput key="search" source="search" alwaysOn />,
  <TextInput key="monthDate" source="monthDate" label="Competência (MM/AAAA)" alwaysOn resettable />,
];

const ListSkippedBilling: React.FC = props => {
  return (
    <Permission permission={PERMISSIONS.INVOICES_REPORT}>
      <List
        {...props}
        title="Reconciliação — Gestão Click x Sistema"
        sort={{ field: 'value', order: 'DESC' }}
        filters={skippedFilters}
        exporter={false}
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="name" label="Cliente (Gestão Click)" sortable={false} />
          <TextField source="cnpj" label="CNPJ" sortable={false} />
          <TextField source="monthDate" label="Competência" sortable={false} />
          <DateField source="dueDate" label="Vencimento" locales="pt-BR" emptyText="--" sortable={false} />
          <NumberField
            source="value"
            label="Valor"
            textAlign="center"
            emptyText="R$ 0,00"
            options={{
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }}
          />
          <ReferenceField
            label="Posto (se cadastrado)"
            source="placeId"
            reference="stations"
            link="edit"
            emptyText="— não cadastrado —"
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <FunctionField
            label="Gestão Click"
            textAlign="center"
            sortable={false}
            render={record => record?.gestaoClickId ? (
              <Button
                size="small"
                startIcon={<OpenInNewIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(`https://gestaoclick.com/financeiro/movimentacoes_financeiras/visualizar_recebimento/${record.gestaoClickId}?retorno=%2Fmovimentacoes_financeiras%2Findex_recebimento`, '_blank');
                }}
              >
                Abrir
              </Button>
            ) : null}
          />
        </Datagrid>
      </List>
    </Permission>
  );
};

export default ListSkippedBilling;
